var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import require$$0, { createContext, useRef, useState, useLayoutEffect, useEffect, useContext } from "react";
window.dataLayer = window.dataLayer || [];
const fetchTrackingTag = (endpoint, params) => {
  return fetch(endpoint, {
    method: "POST",
    body: JSON.stringify(params),
    credentials: "include"
  }).then(async (res) => {
    const { status, message, tags } = await res.json();
    if (!status.startsWith("2")) {
      return Promise.reject(new Error(message));
    }
    return tags;
  });
};
const sendI3PageViewEvents = (serviceCode) => {
  if (window.i3 && serviceCode !== "") {
    try {
      window.i3("init", serviceCode);
      window.i3("create");
      window.i3("send", "view", "page");
    } catch (e) {
      console.error(e);
    }
  }
};
const sendGtmPageViewEvents = () => {
  window.dataLayer.push({
    event: "pageViewEvent",
    pageUrl: `${window.location.pathname}${window.location.search}`,
    pageTitle: document.title
  });
};
const getEndpoint = (env) => {
  switch (env) {
    case "Production": {
      return "https://tag-api.dmm.com/v1.0";
    }
    case "Staging": {
      return "https://stg-tag-api.dmm.com/v1.0";
    }
    default: {
      return "";
    }
  }
};
const TrackingTagContext = createContext({});
var jsxRuntime = { exports: {} };
var reactJsxRuntime_production_min = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(val) {
  if (val === null || val === void 0) {
    throw new TypeError("Object.assign cannot be called with null or undefined");
  }
  return Object(val);
}
function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    }
    var test1 = new String("abc");
    test1[5] = "de";
    if (Object.getOwnPropertyNames(test1)[0] === "5") {
      return false;
    }
    var test2 = {};
    for (var i = 0; i < 10; i++) {
      test2["_" + String.fromCharCode(i)] = i;
    }
    var order2 = Object.getOwnPropertyNames(test2).map(function(n2) {
      return test2[n2];
    });
    if (order2.join("") !== "0123456789") {
      return false;
    }
    var test3 = {};
    "abcdefghijklmnopqrst".split("").forEach(function(letter) {
      test3[letter] = letter;
    });
    if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
      return false;
    }
    return true;
  } catch (err) {
    return false;
  }
}
shouldUseNative() ? Object.assign : function(target, source) {
  var from;
  var to = toObject(target);
  var symbols;
  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);
    for (var key in from) {
      if (hasOwnProperty.call(from, key)) {
        to[key] = from[key];
      }
    }
    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);
      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }
  return to;
};
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f = require$$0, g = 60103;
reactJsxRuntime_production_min.Fragment = 60107;
if (typeof Symbol === "function" && Symbol.for) {
  var h = Symbol.for;
  g = h("react.element");
  reactJsxRuntime_production_min.Fragment = h("react.fragment");
}
var m = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, n = Object.prototype.hasOwnProperty, p = { key: true, ref: true, __self: true, __source: true };
function q(c, a, k) {
  var b, d = {}, e = null, l = null;
  k !== void 0 && (e = "" + k);
  a.key !== void 0 && (e = "" + a.key);
  a.ref !== void 0 && (l = a.ref);
  for (b in a)
    n.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
  if (c && c.defaultProps)
    for (b in a = c.defaultProps, a)
      d[b] === void 0 && (d[b] = a[b]);
  return { $$typeof: g, type: c, key: e, ref: l, props: d, _owner: m.current };
}
reactJsxRuntime_production_min.jsx = q;
reactJsxRuntime_production_min.jsxs = q;
{
  jsxRuntime.exports = reactJsxRuntime_production_min;
}
const jsx = jsxRuntime.exports.jsx;
const jsxs = jsxRuntime.exports.jsxs;
const TrackingTagProvider = ({
  environment,
  params,
  children,
  disabled = false
}) => {
  const ref = useRef(null);
  const locationRef = useRef({
    title: "",
    href: ""
  });
  const [value, setValue] = useState({
    serviceCode: "",
    isLoaded: false
  });
  useLayoutEffect(() => {
    if (ref.current !== null && !disabled) {
      fetchTrackingTag(getEndpoint(environment), params).then((domStr) => {
        const fragment = document.createRange().createContextualFragment(domStr);
        ref.current.appendChild(fragment);
        const result = domStr.match(/i3\('init', ?'(.*)'\)/);
        let serviceCode = "";
        if (result) {
          serviceCode = result[1];
        }
        setValue((prev) => __spreadProps(__spreadValues({}, prev), {
          serviceCode,
          isLoaded: true
        }));
      });
    }
  }, []);
  useEffect(() => {
    if (!value.isLoaded) {
      return;
    }
    const intervalId = setInterval(() => {
      const currentTitle = document.title;
      const currentHref = window.location.href;
      if (locationRef.current.href !== currentHref && locationRef.current.title !== currentTitle) {
        locationRef.current = {
          href: currentHref,
          title: currentTitle
        };
        sendI3PageViewEvents(value.serviceCode);
        sendGtmPageViewEvents();
      }
    }, 500);
    return () => {
      clearInterval(intervalId);
    };
  }, [value.isLoaded]);
  return /* @__PURE__ */ jsxs(TrackingTagContext.Provider, {
    value,
    children: [children, /* @__PURE__ */ jsx("div", {
      ref
    })]
  });
};
const useTrackingTag = () => {
  const context = useContext(TrackingTagContext);
  return {
    serviceCode: context.serviceCode,
    isLoaded: context.isLoaded
  };
};
export { TrackingTagContext, TrackingTagProvider, fetchTrackingTag, getEndpoint, sendGtmPageViewEvents, sendI3PageViewEvents, useTrackingTag };
